import * as React from 'react'
import cx from 'classnames'
import { Modal } from '@local/do-secundo-modal'
import { Button, ButtonVariant } from '@local/do-secundo-button'
import { Notification } from '@local/do-secundo-notification'
import { useDeleteAccount } from '../utils/delete-account-utils'
import { logError } from '@local/do-secundo-error'

export interface DeleteAccountError {
  message: string
  code?: string
}
export interface DeleteAccountModalProps {
  onClose: () => void
  onSuccess: () => void
  testId?: string | number
}

export const DeleteAccountModal = ({
  onClose,
  onSuccess,
  testId = `DeleteAccountModal`
}: DeleteAccountModalProps) => {
  const [error, setError] = React.useState<DeleteAccountError | null>(null)
  const handleDeleteAccount = useDeleteAccount()

  const deleteAccount = async () => {
    try {
      await handleDeleteAccount({ onSuccess, onError: setError })
    } catch (error) {
      setError({
        message:
          "Sorry we're unable to process your request at this time Please try again later."
      })
      logError(error)
    }
  }

  return (
    <div data-testid={testId} className={cx('text-')}>
      <Modal
        header={
          <>
            <h2 className='mx-0 mt-0 mb-3 type-headline-4'>Are you sure?</h2>
            <p className='type-default'>
              Your contact information, order history and payment information
              within your Toast account will be deleted across all Toast
              restaurants. Upon deletion, you will be logged out of all Toast
              products, including the Toast Takeout app, and you will be unable
              to log into this account across any Toast products again. This
              information will not be recoverable. This cannot be undone.
            </p>
          </>
        }
        onClose={onClose}
        responsive={false}
      >
        {error?.message && (
          <div className='px-3 -mb-6'>
            <Notification severity='error'>{error.message}</Notification>
          </div>
        )}
        <div className='flex justify-end p-3'>
          <div className='flex justify-between w-60 pr-2.5'>
            <Button
              variant={ButtonVariant.LINK}
              onClick={deleteAccount}
              data-testid={`${testId}-delete-account-button`}
            >
              Delete account
            </Button>
            <div className='w-24'>
              <Button
                variant={ButtonVariant.PRIMARY_WIDE}
                onClick={onClose}
                data-testid={`${testId}-delete-account-cancel`}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}
